import { Chip, TextField as MUITextField } from '@material-ui/core';
import { Autocomplete as MUIAutocomplete } from '@material-ui/lab';
import { Button } from '@vadiun/react-components';
import { ChoferPartialModel } from 'app/chofer/models/Chofer';
import { Field, Form, Formik } from 'formik';
import { CheckboxWithLabel } from 'formik-material-ui';
import { KeyboardDatePicker } from 'formik-material-ui-pickers';
import { Moment } from 'moment';
import * as Yup from 'yup';

const Schema = Yup.object().shape({
  from: Yup.mixed(),
  to: Yup.mixed(),
  turnoAbierto: Yup.boolean()
});

export type DriverIncomeFiltersFormType = {
  from: Moment | null;
  to: Moment | null;
  driver_ids: number[];
  turnoAbierto: boolean;
};

interface Props {
  onSubmit: (values: DriverIncomeFiltersFormType) => Promise<any>;
  drivers: ChoferPartialModel[];
  initialValues: DriverIncomeFiltersFormType;
}

export const DriverIncomeFiltersForm = ({
  onSubmit,
  initialValues,
  drivers
}: Props) => {
  return (
    <Formik<DriverIncomeFiltersFormType>
      initialValues={initialValues}
      enableReinitialize
      validationSchema={Schema}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <Form className="flex max-w-md flex-col gap-2 p-8">
          <Field
            component={KeyboardDatePicker}
            label="Desde"
            name="from"
            inputVariant="outlined"
            margin="dense"
            className="col-span-2"
            format="DD/MM/YYYY"
          />
          <Field
            component={KeyboardDatePicker}
            label="Hasta"
            name="to"
            inputVariant="outlined"
            margin="dense"
            className="col-span-2"
            format="DD/MM/YYYY"
          />
          <MUIAutocomplete
            multiple
            options={drivers.map((d) => d.id)}
            value={formik.values.driver_ids}
            onChange={(_, value) => formik.setFieldValue('driver_ids', value)}
            getOptionLabel={(option: number) => {
              const driver = drivers.find((d) => d.id === option);
              return driver ? `#${driver.codigo} - ${driver.nombreCompleto}` : '';
            }}
            renderTags={(value: number[], getTagProps) =>
              value.map((option, index) => {
                const driver = drivers.find((d) => d.id === option);
                return (
                  <Chip
                    label={driver ? `#${driver.codigo} - ${driver.nombreCompleto}` : option}
                    {...getTagProps({ index })}
                    size="small"
                  />
                );
              })
            }
            renderInput={(params) => (
              <MUITextField
                {...params}
                label="Choferes"
                variant="outlined"
                margin="dense"
                fullWidth
              />
            )}
          />
          <Field
            component={CheckboxWithLabel}
            type="checkbox"
            name="turnoAbierto"
            color="primary"
            className="col-span-1"
            Label={{ label: 'Turno abierto' }}
          />
          <div className="col-span-1 flex justify-end">
            <Button onClick={formik.submitForm} variant="contained">
              Buscar
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};
